/**
 * Состояние стоп-крана канала.
 *
 * ЧТО ЭТО. Аварийные кнопки владельца: заглушить всё, скрыть всё,
 * заморозить модов (docs/05). Каждая — одно действие без
 * подтверждения: в момент, когда стоп-кран нужен, в эфире уже
 * происходит то, чего быть не должно.
 *
 * ПОЧЕМУ СОСТОЯНИЕ, А НЕ КОМАНДА. Команда дошла бы до тех, кто
 * подключён сейчас. А оверлей переподключается — моргнула сеть,
 * перезапустили OBS, — и вернулся бы со звуком, потому что команду
 * пропустил. Состояние приходит при входе, до первого кадра.
 *
 * Разбор общий у панели и оверлея: две реализации разошлись бы
 * молча и именно там, где это дорого, — панель показывала бы
 * «заглушено», а в эфире шёл звук.
 */
import { decodeMessage } from './message.js';
/** Стоп-кран снят: обычное состояние канала. */
export const RUNNING = { silence: false, hide: false, freeze: false };
/**
 * Разбирает сообщение `stop`.
 *
 * Возвращает `null`, если сообщение не о стоп-кране: вызывающий
 * отличает «не моё» от «снято».
 */
export function parseStop(raw) {
    const message = decodeMessage(raw);
    if (message === null || message.t !== 'stop')
        return null;
    // Отсутствующее поле читается как «не перекрыто». Сервер другой
    // версии, приславший два рубильника из трёх, не должен оставлять
    // третий в неизвестности: «эфир идёт» — то состояние, в котором
    // канал живёт, и умолчанием обязано быть оно
    return {
        silence: message.silence === true,
        hide: message.hide === true,
        freeze: message.freeze === true,
    };
}
//# sourceMappingURL=stop.js.map